'use strict';

app.service('$viewport', function ($window, $rootScope) {

  var self = this;

  var calc = function () {
    var mobile = $window.innerWidth <= 767;
    var tablet = $window.innerWidth <= 979;
    self.isMobile = !!mobile;
    self.isTablet = tablet && !mobile;
    self.isDesktop = !tablet && !mobile;
    self.isLandscape = $window.innerWidth > $window.innerHeight;
  };

  this.init = function () {
    calc();
    angular.element($window).on('resize', _.debounce(function () {
      $rootScope.$apply(calc);
    }, 150));
    return self;
  };

});

app.run(function ($rootScope, $viewport) {
  $rootScope.$viewport = $viewport.init();
});
